import React, {useEffect, useState} from 'react';

import {Loader} from './Loader';
import {useAxiosLoader} from 'utils/hooks/useAxiosLoader/useAxiosLoader';
import {useIsFetching} from '@tanstack/react-query';

const FullScreenLoader = () => {
    const [loading] = useAxiosLoader();
    const [isOpen, setIsOpen] = useState(loading);
    const isGlobalLoading = useIsFetching({
        predicate: (query) =>
            !query.queryKey.includes('getStreamDataByWellId'),
    }) > 0;

    useEffect(() => {
        setIsOpen(loading && !isGlobalLoading);
    }, [loading, isGlobalLoading]);

    return <Loader show={isOpen} />;
};

export default FullScreenLoader;
